import React from "react";
import BaseSubscriptionPopup from "../Popup/BaseSubscriptionPopup";
import { t } from "i18next";

const NonPremiumMaxJoinPopup = ({ isOpen, onClose, title, onSubscriptionBtnClick, message }) => {
  return (
    <BaseSubscriptionPopup isOpen={isOpen} onClose={onClose} title={title} onSubscriptionBtnClick={onSubscriptionBtnClick}>
      <div className="mb-5">
        {/* <p className="text-subscription text-center f-16">
        Is your request urgent? premium users can get their queries resolved by
        one of our dedicated customer care reps.
      </p> */}
        <p className="text-subscription text-center f-16">
          {message}
          {/* {t('premium.you_have_already_joined_today', { title: title, total: type === 'tournament' ? localStorage?.getItem('noOfTournament') : type === 'contest' ? localStorage?.getItem('noOfContest') : localStorage?.getItem('noOfPrivateContest') })} */}
        </p>
      </div>
    </BaseSubscriptionPopup>
  );
};

export default NonPremiumMaxJoinPopup;
